import { StyleSheet } from 'react-native';

export const promoStyles = StyleSheet.create({
  title: {
    marginHorizontal: 10,
    marginTop: 10,
    fontSize: 16,
    fontWeight: 800,
    //  color: 'red'
  },

  promoWrapper: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'black',
    color: 'white',
    height: 80,
    padding: 10,
    borderRadius: 10,
    width: 160,
    marginTop: 10,
    marginLeft: 10,
    marginRight: 20,
  },

  promoWrapper2: {
    backgroundColor: '#396858',
    display: 'flex',
    flexDirection: 'row',
    color: 'white',
    height: 80,
    padding: 10,
    borderRadius: 10,
    width: 160,
    marginTop: 10,
    marginLeft: 10,
    marginRight: 20,
  },

  promoCopy: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  promoText: {
    color: 'white',
  },

  promoText2: {
    color: 'yellow',
    fontWeight: 'bold',
    marginTop: 5,
    fontSize: 15,
  },

  promoPic: {
    position: 'absolute',
    right: -30,
    bottom: -12,
    height: 95,
    width: 95,
  },
});
